export default __webpack_public_path__ + "static/standardSharingImage-c8bc69402c65d4f6a8319a1e6fa07dca.jpg";